import { Component } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { BaseListComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-list.component";
import { ITab, TabularService } from "projects/sepidz-web-framework-shell/src/lib/tabular/tabular.service ";
import { EntityListAction, FiscalYear, form_control, Permission } from "projects/sepidz-web-framework/src/lib/models";
import { Datatransfer, VoucherKindInfo } from "projects/sepidz-web-framework/src/lib/models/datatransfer.model";
import { EntityBase } from "projects/sepidz-web-framework/src/lib/models/entity-base.model";
import { GridFilter } from "projects/sepidz-web-framework/src/lib/services";
import { takeUntil } from "rxjs/operators";
import { AccVoucherFormComponent } from "src/app/backoffice/acc/accvoucher/accvoucher-form/accvoucher-form.component";
import { ReviewFilterItem } from "src/app/review/models/review-filter-item";
import { ReviewService } from "src/app/review/review.service";
import { TrsVoucherFormComponent } from "../../trs-voucher/trs-voucher-form/trs-voucher-form.component";

@Component({
  selector: "ngx-treasury-review",
  templateUrl: "./treasury-review.component.html",
  styleUrls: ["./treasury-review.component.scss"],
  providers: [ReviewService],
})
export class TreasuryReviewComponent extends BaseListComponent {
  formGroup: UntypedFormGroup;
  actions: EntityListAction[];
  GetTrsVoucherKindColumns: form_control[] = [];
  GetDetailLedgerColumns: form_control[] = [];
  GetCashColumns: form_control[] = [];
  GetTreasuryDetailLedgerColumns: form_control[] = [];
  GetVoucherHeaderColumns: form_control[] = [];
  GetVoucherDetailColumns: form_control[] = [];
  GetTreasuryHistoryColumns: form_control[] = [];
  TrsVoucherKindIds: number[] = [];
  StatusKindIds: number[] = [];
  DetailLedgerIds: number[] = [];
  BankAccountIds: number[] = [];
  BranchIds: number[] = [];
  TrsConcernIds: number[] = [];
  VoucherHeaderIds: number[] = [];
  OperationKindIds: number[] = [];
  DocumentKindIds: number[] = [];
  CashIds: number[] = [];
  activeTabTitle: string;
  selected: string = "";
  constructor(private service: ReviewService, private tabsservice: TabularService, private fb: UntypedFormBuilder) {
    super();
    this.onActionClick = this.onActionClick.bind(this);
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
    this.formGroup = undefined;
    this.actions = undefined;
    this.GetTrsVoucherKindColumns = undefined;
    this.GetDetailLedgerColumns = undefined;
    this.GetCashColumns = undefined;
    this.GetTreasuryDetailLedgerColumns = undefined;
    this.GetVoucherHeaderColumns = undefined;
    this.GetVoucherDetailColumns = undefined;
    this.GetTreasuryHistoryColumns = undefined;
    this.TrsVoucherKindIds = undefined;
    this.StatusKindIds = undefined;
    this.DetailLedgerIds = undefined;
    this.BankAccountIds = undefined;
    this.BranchIds = undefined;
    this.TrsConcernIds = undefined;
    this.VoucherHeaderIds = undefined;
    this.OperationKindIds = undefined;
    this.DocumentKindIds = undefined;
    this.CashIds = undefined;
  }
  ngOnInit(): void {
    //this.service.startDate = new Date();
    //this.service.endDate = new Date();
    this.setactions();

    let currentFiscalYear = this.accountService.authService.currentFiscalYear;
    if (currentFiscalYear) {
      this.service.startDate.setDate(this.service.startDate.getDate() - 30);
      this.service.startDate$.next(this.service.startDate);
      if (currentFiscalYear && currentFiscalYear.StartDate) {
        let fystartDate = new Date(currentFiscalYear.StartDate);
        if (fystartDate.setHours(0, 0, 0, 0) > this.service.startDate.setHours(0, 0, 0, 0))
          this.service.startDate = this.accountService.authService.currentFiscalYear.StartDate;
        else if (fystartDate.setHours(0, 0, 0, 0) < this.service.startDate.setHours(0, 0, 0, 0)) {
          this.service.startDate = currentFiscalYear.StartDate;
          this.service.endDate = currentFiscalYear.EndDate;
          this.service.startDate$.next(currentFiscalYear.StartDate);
          this.service.endDate$.next(currentFiscalYear.EndDate);
        }
      }
    } else
      this.accountService.authService.currentFiscalYearobsr.pipe(takeUntil(this.ngUnsubscribe)).subscribe((x: FiscalYear) => {
        if (x && x.StartDate) {
          this.service.startDate.setDate(this.service.startDate.getDate() - 30);
          let fystartDate = new Date(x.StartDate);
          if (fystartDate.setHours(0, 0, 0, 0) > this.service.startDate.setHours(0, 0, 0, 0)) this.service.startDate = x.StartDate;
          else if (fystartDate.setHours(0, 0, 0, 0) < this.service.startDate.setHours(0, 0, 0, 0)) {
            this.service.startDate = x.StartDate;
            this.service.endDate = x.EndDate;
            this.service.startDate$.next(currentFiscalYear.StartDate);
            this.service.endDate$.next(currentFiscalYear.EndDate);
          }
        }
      });
    this.BranchIds.push(this.accountService.authService.currentBranchId);
    this.service.addFilter(this.accountService.authService.currentBranch.Title, [
      <ReviewFilterItem>{
        key: "BranchIds",
        value: this.accountService.authService.currentBranchId,
        title: this.accountService.authService.currentBranch.Title,
        persianKey: this.accountService.authService.currentBranch.Title,
      },
    ]);
    this.formGroup = this.fb.group({
      TrsVoucherKindIds: this.TrsVoucherKindIds,
      StatusKindIds: this.StatusKindIds,
      BranchIds: this.BranchIds,
      TrsConcernIds: this.TrsConcernIds,
      ShowRunningTotal: false,
      DocumentKindIds: this.DocumentKindIds,
      OperationKindIds: this.OperationKindIds,
      DetailLedgerIds: this.DetailLedgerIds,
      BankAccountIds: this.BankAccountIds,
      CashIds: this.CashIds,
      SlaveNo: undefined,
      ShowBeginingOfTheCoursResidue: false,
      IsEstablishment: false,
      VoucherHeaderIds: this.VoucherHeaderIds,
    });
    this.populateGridColumns();
    this.setColumns();
  }
  setColumns() {
    this.httpCommonService
      .get("TreasuryReview/GetTreasuryReviewInfo")
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (data) => {
          if (data) {
            this.GetVoucherDetailColumns = data as form_control[];
            this.GetVoucherDetailColumns = this.GetVoucherDetailColumns.sort((a, b) => a.order - b.order);
            this.setColumnVisiblty();
          }
        },
        (error) => console.log(error)
      );
  }
  setColumnVisiblty() {}
  populateGridColumns(): any {
    var col: form_control[] = [];
    col = [
      {
        name: "Id",
        modelName: "Id",
        listVisible: false,
        label: "سریال",
        order: 0,
        textType: "number",
        withComma: false,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      // { name: 'BankBranchTitle', modelName: 'BankBranchTitle', listVisible: true, label: 'شعبه', order: 13, textType: 'text', withComma: true, isDecimal: true, formVisible: false, disabled: false, areaName: null, systemName: undefined, category: undefined, DetailControlModels: undefined },
      // { name: 'BankAccountNo', modelName: 'BankAccountNo', listVisible: true, label: 'شعبه', order: 14, textType: 'text', withComma: true, isDecimal: true, formVisible: false, disabled: false, areaName: null, systemName: undefined, category: undefined, DetailControlModels: undefined },
      {
        name: "ReceptionAmount",
        modelName: "ReceptionAmount",
        listVisible: true,
        label: "دریافت",
        order: 15,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "NetReceptionAmount",
        modelName: "NetReceptionAmount",
        listVisible: false,
        label: "دریافت نقد",
        order: 16,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "PaymentAmount",
        modelName: "PaymentAmount",
        listVisible: true,
        label: "پرداخت",
        order: 17,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "NetPaymentAmount",
        modelName: "NetPaymentAmount",
        listVisible: false,
        label: "پرداخت نقد",
        order: 18,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "RemainAmount",
        modelName: "RemainAmount",
        listVisible: true,
        label: "مانده",
        order: 19,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "PayableDocumentAmount",
        modelName: "PayableDocumentAmount",
        listVisible: true,
        label: "اسناد پرداختنی",
        order: 20,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "ReceptionDocumentAmount",
        modelName: "ReceptionDocumentAmount",
        listVisible: true,
        label: "اسناد دریافتنی",
        order: 21,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
    ];

    Object.assign(this.GetTrsVoucherKindColumns, col);
    this.GetTrsVoucherKindColumns.push({
      name: "VoucherKindCode",
      modelName: "VoucherKindCode",
      listVisible: true,
      label: "کد",
      order: 1,
      textType: "number",
      withComma: false,
      formVisible: false,
      disabled: false,
      areaName: null,
      systemName: undefined,
      category: undefined,
      DetailControlModels: undefined,
    });
    this.GetTrsVoucherKindColumns.push({
      name: "VoucherKindTitle",
      modelName: "VoucherKindTitle",
      listVisible: true,
      label: "عنوان",
      order: 2,
      textType: "text",
      withComma: false,
      formVisible: false,
      disabled: false,
      areaName: null,
      systemName: undefined,
      category: undefined,
      DetailControlModels: undefined,
    });
    this.GetTrsVoucherKindColumns = this.GetTrsVoucherKindColumns.sort((a, b) => a.order - b.order);

    Object.assign(this.GetDetailLedgerColumns, col);
    this.GetDetailLedgerColumns.push({
      name: "DetailLedgerCode",
      modelName: "DetailLedgerCode",
      listVisible: true,
      label: "کد",
      order: 1,
      textType: "number",
      withComma: false,
      formVisible: false,
      disabled: false,
      areaName: null,
      systemName: undefined,
      category: undefined,
      DetailControlModels: undefined,
    });
    this.GetDetailLedgerColumns.push({
      name: "DetailLedgerTitle",
      modelName: "DetailLedgerTitle",
      listVisible: true,
      label: "عنوان",
      order: 2,
      textType: "text",
      withComma: false,
      formVisible: false,
      disabled: false,
      areaName: null,
      systemName: undefined,
      category: undefined,
      DetailControlModels: undefined,
    });
    this.GetDetailLedgerColumns = this.GetDetailLedgerColumns.sort((a, b) => a.order - b.order);

    Object.assign(this.GetTreasuryDetailLedgerColumns, col);
    this.GetTreasuryDetailLedgerColumns.push({
      name: "BankTitle",
      modelName: "BankTitle",
      listVisible: true,
      label: "بانک",
      order: 1,
      textType: "number",
      withComma: false,
      formVisible: false,
      disabled: false,
      areaName: null,
      systemName: undefined,
      category: undefined,
      DetailControlModels: undefined,
    });
    this.GetTreasuryDetailLedgerColumns.push({
      name: "BankBranchTitle",
      modelName: "BankBranchTitle",
      listVisible: true,
      label: "شعبه",
      order: 2,
      textType: "text",
      withComma: false,
      formVisible: false,
      disabled: false,
      areaName: null,
      systemName: undefined,
      category: undefined,
      DetailControlModels: undefined,
    });
    this.GetTreasuryDetailLedgerColumns.push({
      name: "BankAccountNo",
      modelName: "BankAccountNo",
      listVisible: true,
      label: "حساب بانکی",
      order: 3,
      textType: "text",
      withComma: false,
      formVisible: false,
      disabled: false,
      areaName: null,
      systemName: undefined,
      category: undefined,
      DetailControlModels: undefined,
    });
    this.GetTreasuryDetailLedgerColumns.push({
      name: "TreasuryDetailLedgerTitle",
      modelName: "TreasuryDetailLedgerTitle",
      listVisible: true,
      label: "تفصیلی حساب بانکی",
      order: 4,
      textType: "text",
      withComma: false,
      formVisible: false,
      disabled: false,
      areaName: null,
      systemName: undefined,
      category: undefined,
      DetailControlModels: undefined,
    });

    this.GetTreasuryDetailLedgerColumns = this.GetTreasuryDetailLedgerColumns.sort((a, b) => a.order - b.order);

    Object.assign(this.GetCashColumns, col);
    this.GetCashColumns.push({
      name: "CashTitle",
      modelName: "CashTitle",
      listVisible: true,
      label: "عنوان",
      order: 2,
      textType: "text",
      withComma: false,
      formVisible: false,
      disabled: false,
      areaName: null,
      systemName: undefined,
      category: undefined,
      DetailControlModels: undefined,
    });
    this.GetCashColumns = this.GetCashColumns.sort((a, b) => a.order - b.order);

    Object.assign(this.GetVoucherHeaderColumns, col);
    this.GetVoucherHeaderColumns.push({
      name: "VoucherKindTitle",
      modelName: "VoucherKindTitle",
      listVisible: true,
      label: "نوع سند",
      order: 1,
      textType: "text",
      withComma: false,
      formVisible: false,
      disabled: false,
      areaName: null,
      systemName: undefined,
      category: undefined,
      DetailControlModels: undefined,
    });
    this.GetVoucherHeaderColumns.push({
      name: "VoucherNo",
      modelName: "VoucherNo",
      listVisible: true,
      label: "شماره سند",
      order: 2,
      textType: "number",
      withComma: false,
      formVisible: false,
      disabled: false,
      areaName: null,
      systemName: undefined,
      category: undefined,
      DetailControlModels: undefined,
    });
    this.GetVoucherHeaderColumns.push({
      name: "ShamsiVoucherDate",
      modelName: "ShamsiVoucherDate",
      listVisible: true,
      label: "تاریخ سند",
      order: 3,
      textType: "text",
      withComma: false,
      formVisible: false,
      disabled: false,
      areaName: null,
      systemName: undefined,
      category: undefined,
      DetailControlModels: undefined,
    });
    this.GetVoucherHeaderColumns.push({
      name: "ShamsiDocumentDate",
      modelName: "ShamsiDocumentDate",
      listVisible: true,
      label: "تاریخ سررسید",
      order: 4,
      textType: "text",
      withComma: false,
      formVisible: false,
      disabled: false,
      areaName: null,
      systemName: undefined,
      category: undefined,
      DetailControlModels: undefined,
    });
    this.GetVoucherHeaderColumns.push({
      name: "SlaveNo",
      modelName: "SlaveNo",
      listVisible: true,
      label: "َشماره پیگیری",
      order: 6,
      textType: "number",
      withComma: false,
      formVisible: false,
      disabled: false,
      areaName: null,
      systemName: undefined,
      category: undefined,
      DetailControlModels: undefined,
    });
    this.GetVoucherHeaderColumns.push({
      name: "DetailLedgerCode",
      modelName: "DetailLedgerCode",
      listVisible: true,
      label: "کد طرف مقابل",
      order: 7,
      textType: "number",
      withComma: false,
      formVisible: false,
      disabled: false,
      areaName: null,
      systemName: undefined,
      category: undefined,
      DetailControlModels: undefined,
    });
    this.GetVoucherHeaderColumns.push({
      name: "DetailLedgerTitle",
      modelName: "DetailLedgerTitle",
      listVisible: true,
      label: "طرف مقابل",
      order: 8,
      textType: "text",
      withComma: false,
      formVisible: false,
      disabled: false,
      areaName: null,
      systemName: undefined,
      category: undefined,
      DetailControlModels: undefined,
    });
    this.GetVoucherHeaderColumns = this.GetVoucherHeaderColumns.sort((a, b) => a.order - b.order);
  }
  isActveTab(title: string) {
    return this.activeTabTitle === title;
  }
  selectTab($event) {
    this.activeTabTitle = $event.tabTitle;
  }
  onActionClick(action: EntityListAction, onRowSelected: any, onRowsSelected: any[], isAllSelected: boolean, gridFilter: GridFilter[]) {
    var datatrasfer: Datatransfer = <Datatransfer>{};
    datatrasfer.apiName = action.apiName;
    datatrasfer.label = this.label;
    datatrasfer.areaName = action.areaName;
    datatrasfer.currentrow = onRowSelected;

    ///سند حسابداری
    if (action.name === "AccVoucherHeader") {
      if (!onRowSelected["AccVoucherHeaderId"]) {
        this.sts.showDialog("سند حسابداری صادر نشده است.", "");
        return;
      }
      const menu = <ITab>{
        title: `مرور دریافت و پردخت   (${onRowSelected["VoucherKindTitle"]})`,
        isCloseable: true,
        icon: action.iconName,
        active: true,
        responsive: true,
        componentType: action.Form_Component,
        modulePath: this.tabsservice.getActiveTab().modulePath,
        data: [
          { provide: EntityBase, useValue: onRowSelected },
          { provide: Datatransfer, useValue: datatrasfer },
          { provide: VoucherKindInfo, useValue: <VoucherKindInfo>{ VoucherKindId: onRowSelected[""] } },
        ],
      };
      this.tabsservice.open(menu);
    }
    /// سند مبنا
    if (action.name === "BaseVoucher") {
      const menu = <ITab>{
        title: `مرور دریافت و پردخت   (${onRowSelected["VoucherKindTitle"]})`,
        isCloseable: true,
        icon: action.iconName,
        active: true,
        responsive: true,
        componentType: action.Form_Component,
        modulePath: this.tabsservice.getActiveTab().modulePath,
        data: [
          { provide: EntityBase, useValue: onRowSelected },
          { provide: Datatransfer, useValue: datatrasfer },
          { provide: VoucherKindInfo, useValue: <VoucherKindInfo>{ VoucherKindId: onRowSelected["TrsVoucherKindId"] } },
        ],
      };
      this.tabsservice.open(menu);
    }
  }
  setactions() {
    this.actions = [
      {
        name: "AccVoucherHeader",
        disabled: false,
        isModal: true,
        displayName: "نمایش سند حسابداری",
        iconName: "icon-table_view-f",
        Form_Component: AccVoucherFormComponent,
        apiName: "AccVoucherHeader",
        areaName: "Accounting",
        permission: Permission.viewPermission,
      },
      {
        name: "BaseVoucher",
        disabled: false,
        isModal: true,
        displayName: "سند مبنا گزارش",
        iconName: "icon-folder-open-outline",
        areaName: "Treasury",
        Form_Component: TrsVoucherFormComponent,
        apiName: "TrsVoucherHeader",
        permission: Permission.viewPermission,
      },
      {
        name: "GetTreasuryHistory",
        disabled: false,
        displayName: "تاریخچه",
        iconName: "icon-history-o",
        areaName: "Inventory",
        Form_Component: TrsVoucherFormComponent,
        apiName: "TreasuryReview/GetTreasuryHistory",
        permission: Permission.samePermission,
      },
    ];
  }
  setSelectedFilter(filter: string) {
    if (this.selected === filter) this.selected = "";
    else this.selected = filter;
  }
}
